import kr from '../../kr/kr';

export default class Mansory extends kr.Component {
    init() {
        this._assetUrl = 'https://cdn.jsdelivr.net/npm/macy@2';
        this.macy = null;
        this.app.addJs(this._assetUrl, true, this._bind.bind(this));
        this.columns = this.$element.getAttribute('data-column') || 5;
        this.breakpointString = this.$element.getAttribute('data-breakpoint') || '1200:3|991:3|768:2|550:1';
        this.breakpoints = {};
        const array = this.breakpointString.split('|');
        for (let i in array) {
            const ar = array[i].split(':');
            this.breakpoints[ar[0]] = ar[1];
        }
    }

    _bind() {
        this.macy = new Macy({
            container: this.$element,
            trueOrder: false,
            waitForImages: false,
            margin: 15,
            columns: this.columns,
            breakAt: this.breakpoints
        });
    }

}

kr.registerComponent('.js_mansory', {
    component: Mansory
});